import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Table from "../../../components/Table/Table";
import styles from "./TranslationLog.module.scss";
import { PdApiActions, pdApiActions } from "../../../actions/pdApiActions";

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  isLoadingTranslationLog: boolean;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {
  subMenuRoute: State.UserSubmenu;
  toggleModal: () => void;
};

export type TranslationLogProps = StateProps & DispatchProps & OwnProps;

type TranslationLogState = {};

export class TranslationLog extends React.Component<TranslationLogProps, TranslationLogState> {
  componentDidMount(): void {
        this.props.pdApiActions.fetchTranslationLogItems();
  }

  render(): JSX.Element {
    const { columns, pdApi, mainState, isLoadingTranslationLog } = this.props;
    const { translationLogItems } = pdApi;
    const { pageSize } = mainState;
    let selectedColumns: State.Column[] = [];

    const rows: Api.TranslationLogItem[] = [...translationLogItems].sort((a, b) =>
      a.translationDate < b.translationDate ? 1 : -1
    );

    selectedColumns = columns["Translation Log"];

    return (
      <> 
        <div className={styles.translationLogHeader}>
          <div className="flex-1">
            <div className="flex-1">
              <Table
                rows={rows}
                columns={selectedColumns}
                isHidingTextActive={false}
                handleRowSelection={() => null}
                isRowSelected={() => false}
                pageSize={pageSize}
                loading={isLoadingTranslationLog}
                loadingText="Fetching Translation Logs..."
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  isLoadingTranslationLog: state.loadingStatus.isLoadingTranslationLog,
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TranslationLog);
